import { cloneElement } from "react";
import PropTypes from "prop-types";
const ConditionalWrapper = _ref => {
  let {
    condition,
    wrapper,
    children
  } = _ref;
  return condition ? /*#__PURE__*/cloneElement(wrapper, null, children) : children;
};
ConditionalWrapper.prototypes = {
  /** A condition if met, will render the wrapper around the children */
  condition: PropTypes.bool,
  /** An instance of a React element that is used to conditionally wrap the children */
  wrapper: PropTypes.node,
  /** The children that will be conditionally wrapped */
  children: PropTypes.node
};
export default ConditionalWrapper;